import React from 'react'
import styled from 'styled-components'

import Field, {
  required,
} from '../../../../../../../1stlog-ui/src/components/Field'
import Input from '../../../../../../../1stlog-ui/src/components/Input'
import Select from '../../../../../../../1stlog-ui/src/components/Select'
import Tooltip from '../../../../../../../1stlog-ui/src/components/Tooltip'

const Wrapper = styled.div``

const ClassCode = (props) => {
  const {} = props

  const options = [
    {
      value: null,
      label: i18n.t('label_none', 'Keine'),
    },
    {
      value: '1',
      label: (
        <span>
          1{' '}
          <Tooltip text={i18n.t('hazmat_code_1', 'Explosive Stoffe')}>
            <i className="mdi mdi-help-circle " />
          </Tooltip>
        </span>
      ),
    },
    {
      value: '2',
      label: (
        <span>
          2{' '}
          <Tooltip text={i18n.t('hazmat_code_2', 'Gase und gasförmige Stoffe')}>
            <i className="mdi mdi-help-circle " />
          </Tooltip>
        </span>
      ),
    },
    {
      value: '2.1',
      label: (
        <span>
          2.1{' '}
          <Tooltip
            text={i18n.t('hazmat_code_2_1', 'Gase und gasförmige Stoffe')}
          >
            <i className="mdi mdi-help-circle " />
          </Tooltip>
        </span>
      ),
    },
    {
      value: '2.2',
      label: (
        <span>
          2.2{' '}
          <Tooltip
            text={i18n.t('hazmat_code_2_2', 'Gase und gasförmige Stoffe')}
          >
            <i className="mdi mdi-help-circle " />
          </Tooltip>
        </span>
      ),
    },
    {
      value: '2.3',
      label: (
        <span>
          2.3{' '}
          <Tooltip
            text={i18n.t('hazmat_code_2_3', 'Gase und gasförmige Stoffe')}
          >
            <i className="mdi mdi-help-circle " />
          </Tooltip>
        </span>
      ),
    },
    {
      value: '3',
      label: (
        <span>
          3{' '}
          <Tooltip
            text={i18n.t('hazmat_code_3', 'Entzündbare flüssige Stoffe')}
          >
            <i className="mdi mdi-help-circle " />
          </Tooltip>
        </span>
      ),
    },
    // {
    //   value: "4",
    //   label: (
    //     <span>
    //       4{" "}
    //       <Tooltip text="Entzündbare flüssige Stoffe">
    //         <i className="mdi mdi-help-circle " />
    //       </Tooltip>
    //     </span>
    //   )
    // },
    {
      value: '4.1',
      label: (
        <span>
          4.1{' '}
          <Tooltip
            text={i18n.t('hazmat_code_4_1', 'Entzündbare flüssige Stoffe')}
          >
            <i className="mdi mdi-help-circle " />
          </Tooltip>
        </span>
      ),
    },
    {
      value: '4.2',
      label: (
        <span>
          4.2{' '}
          <Tooltip
            text={i18n.t('hazmat_code_4_2', 'Entzündbare flüssige Stoffe')}
          >
            <i className="mdi mdi-help-circle " />
          </Tooltip>
        </span>
      ),
    },
    {
      value: '4.3',
      label: (
        <span>
          4.3{' '}
          <Tooltip
            text={i18n.t('hazmat_code_4_3', 'Entzündbare flüssige Stoffe')}
          >
            <i className="mdi mdi-help-circle " />
          </Tooltip>
        </span>
      ),
    },
    {
      value: '5.1',
      label: (
        <span>
          5.1{' '}
          <Tooltip
            text={i18n.t(
              'hazmat_code_5_1',
              'Entzündend (oxidierend) wirkende Stoffe',
            )}
          >
            <i className="mdi mdi-help-circle " />
          </Tooltip>
        </span>
      ),
    },
    {
      value: '5.2',
      label: (
        <span>
          5.2{' '}
          <Tooltip
            text={i18n.t(
              'hazmat_code_5_2',
              'Entzündend (oxidierend) wirkende Stoffe',
            )}
          >
            <i className="mdi mdi-help-circle " />
          </Tooltip>
        </span>
      ),
    },
    {
      value: '6.1',
      label: (
        <span>
          6.1{' '}
          <Tooltip text={i18n.t('hazmat_code_6_1', 'Giftige Stoffe')}>
            <i className="mdi mdi-help-circle " />
          </Tooltip>
        </span>
      ),
    },
    {
      value: '6.2',
      label: (
        <span>
          6.2{' '}
          <Tooltip text={i18n.t('hazmat_code_6_2', 'Giftige Stoffe')}>
            <i className="mdi mdi-help-circle " />
          </Tooltip>
        </span>
      ),
    },
    {
      value: '7',
      label: (
        <span>
          7{' '}
          <Tooltip text={i18n.t('hazmat_code_7', 'Radioaktive Stoffe')}>
            <i className="mdi mdi-help-circle " />
          </Tooltip>
        </span>
      ),
    },
    {
      value: '8',
      label: (
        <span>
          8{' '}
          <Tooltip text={i18n.t('hazmat_code_8', 'Ätzende Stoffe')}>
            <i className="mdi mdi-help-circle " />
          </Tooltip>
        </span>
      ),
    },
    {
      value: '9',
      label: (
        <span>
          9{' '}
          <Tooltip
            text={i18n.t(
              'hazmat_code_9',
              'Verschiedene gefährliche Stoffe und Gegenstände',
            )}
          >
            <i className="mdi mdi-help-circle " />
          </Tooltip>
        </span>
      ),
    },
    {
      value: '9A',
      label: (
        <span>
          9A{' '}
          <Tooltip
            text={i18n.t(
              'hazmat_code_9a',
              'Verschiedene gefährliche Stoffe und Gegenstände',
            )}
          >
            <i className="mdi mdi-help-circle " />
          </Tooltip>
        </span>
      ),
    },
  ]

  return (
    <Wrapper className="d-flex">
      <div className="flex-fill">
        <Field label={i18n.t('label_class', 'Klasse')} name="class">
          <Select
            options={options}
            direct
            clearable={false}
            searchable
            placeholder={i18n.t('label_none', 'Keine')}
          />
        </Field>
      </div>
      <div className="ml-1" style={{ width: '70px' }}>
        <Field
          label={i18n.t('label_class_code', 'Code')}
          name="classCode"
          clearable={false}
          required
          validate={required}
        >
          <Input />
        </Field>
      </div>
    </Wrapper>
  )
}

export default ClassCode
